import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomAlert } from 'components/AlertsCollection';

interface MeteorologyAgroGroupLocationFeedbackState {
  deleteSuccessDialogOpen: boolean;
  deleteErrorDialogOpen: boolean;
  deleteMessage: string | undefined;
  createAlert: CustomAlert | undefined;
  editAlert: CustomAlert | undefined;
}

const initialState: MeteorologyAgroGroupLocationFeedbackState = {
  deleteSuccessDialogOpen: false,
  deleteErrorDialogOpen: false,
  deleteMessage: undefined,
  createAlert: undefined,
  editAlert: undefined,
};

export const meteorologyAgroGroupLocationFeedbackSlice = createSlice({
  name: 'meteorologyAgroGroupLocationFeedback',
  initialState,
  reducers: {
    setDeleteSuccessDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.deleteSuccessDialogOpen = action.payload;
    },
    setDeleteErrorDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.deleteErrorDialogOpen = action.payload;
    },
    setDeleteMessage: (state, action: PayloadAction<string | undefined>) => {
      state.deleteMessage = action.payload;
    },
    setCreateAlert: (state, action: PayloadAction<CustomAlert | undefined>) => {
      state.createAlert = action.payload;
    },
    setEditAlert: (state, action: PayloadAction<CustomAlert | undefined>) => {
      state.editAlert = action.payload;
    },
  },
});

export const selectMeteorologyAgroGroupLocationDeleteSuccessDialogOpen = (state: any) => (
  state.meteorologyAgroGroupLocationFeedback.deleteSuccessDialogOpen
);

export const selectMeteorologyAgroGroupLocationDeleteErrorDialogOpen = (state: any) => (
  state.meteorologyAgroGroupLocationFeedback.deleteErrorDialogOpen
);

export const selectMeteorologyAgroGroupLocationMessage = (state: any) => (
  state.meteorologyAgroGroupLocationFeedback.deleteMessage
);

export const selectMeteorologyAgroGroupLocationCreateAlert = (state: any) => (
  state.meteorologyAgroGroupLocationFeedback.createAlert
);

export const selectMeteorologyAgroGroupLocationEditAlert = (state: any) => (
  state.meteorologyAgroGroupLocationFeedback.editAlert
);

export const {
  setDeleteSuccessDialogOpen,
  setDeleteErrorDialogOpen,
  setDeleteMessage,
  setCreateAlert,
  setEditAlert,
} = meteorologyAgroGroupLocationFeedbackSlice.actions;

export default meteorologyAgroGroupLocationFeedbackSlice.reducer;
